<template>
  <v-app>
    <div class="vue-component app">
      <DynamicForm />
    </div>
  </v-app>
</template>

<script>
import DynamicForm from './components/DynamicForm.vue'
import baseAppFactory from '../common/baseAppFactory'

export default baseAppFactory({ DynamicForm })
</script>
<style scoped>
.app {
  padding: 0 1rem;
}
</style>
<style>
#dynamic-form .v-application__wrap {
  min-height: auto;
}
</style>
